import './App.css';
import hotImg from './assets/hot.png';
import HeaderComponent from './components/Header';
import FooterComponent from './components/Footer';
import React, { useState, useEffect, useRef } from 'react';
import { Flex, Layout, Row, Col } from 'antd';
import unit from './unit';
import { useNavigate } from 'react-router-dom';
const { Content } = Layout;

// 热搜榜页面元信息配置
const metaConfig = {
  title: '热搜榜-实时查看热门机构、牛散、基金、国家队持仓明细_仓位在线',
  keywords: '机构,牛散,基金,国家队,qfii',
  description: '仓位在线热搜榜频道为投资者提供最新热门机构的持仓明细+持仓成本数据，通过对近期热门机构等增持、减持、新进股票的持仓比例+持仓成本的深入分析，跟随市场主流热门机会'
};

// 热搜榜
const HotSearch = () => {
    const navigate = useNavigate();
    const [dataSource, setDataSource] = useState([]);
    const [tagItems, setTabsItems] = useState([
        {"k":"全部",   "v": 0},
        {"k":"知名机构",   "v": 1},
        {"k":"牛散",   "v": 2},
        {"k":"金牛基金",   "v": 3},
        {"k":"国家队", "v": 4},
        {"k":"外资",   "v": 5},
    ]);
    const [type, setType] = useState(0);
    const [lastClickedName, setLastClickedName] = useState(''); // 保存上次点击的对象名称
    const childRef = useRef(null);

    // 更新页面元信息
    const updateMetaInfo = () => {
        // 设置页面标题
        document.title = metaConfig.title;
        
        // 设置keywords
        const metaKeywords = document.querySelector('meta[name="keywords"]');
        if (metaKeywords) {
            metaKeywords.setAttribute('content', metaConfig.keywords);
        } else {
            const newMeta = document.createElement('meta');
            newMeta.setAttribute('name', 'keywords');
            newMeta.setAttribute('content', metaConfig.keywords);
            document.head.appendChild(newMeta);
        }
        
        // 设置description
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute('content', metaConfig.description);
        } else {
            const newMeta = document.createElement('meta');
            newMeta.setAttribute('name', 'description');
            newMeta.setAttribute('content', metaConfig.description);
            document.head.appendChild(newMeta);
        }
    };

    const getHotList = () => {
        const path = '/pc/gudong/getHotSearch';
        unit.httpGet(path, {"type": type, "page": 1, "pageSize": 50}, (data) => {
            if (data.list.length > 0) {
                let _dataSource = [];
                for (let i = 0; i < data.list.length; i++) {
                    let tmp = {};
                    tmp['index'] = i;
                    tmp['code'] = data.list[i].code;
                    tmp['name'] = data.list[i].name;
                    _dataSource.push(tmp);
                }
                setDataSource(_dataSource);
            }
        });
    }

    useEffect(() => {
        // 从localStorage中读取上次的状态
        const savedName = localStorage.getItem('hotSearchLastClickedName');
        if (savedName !== null) {
            setLastClickedName(savedName);
        }
        getHotList();
        updateMetaInfo(); // 初始化时设置元信息
    }, [type]);

    // 切换类型
    const onTagClick = (v) => {
        setType(v);
    }

    // 点击列表项
    const onListItemClick = (code, name) => {
        window.open(`/detail/${code}`, '_blank'); // 在新窗口打开链接
        setLastClickedName(name); // 更新上次点击的名称
        localStorage.setItem('hotSearchLastClickedName', name); // 保存上次点击的名称
    }

    return (
        <div className="App">
            <Flex gap="middle" wrap>
                <Layout>
                    <HeaderComponent ref={childRef}></HeaderComponent>
                    <Content>
                        <div className='hot-container'>
                            <div className='block-title'>
                                <img className='title-icon' src={hotImg}/> <span style={{verticalAlign: 'middle'}}>热搜榜</span>
                            </div>
                            <div className='tag-container'>
                                <Flex gap="small" wrap>
                                {tagItems.length > 0 ? tagItems.map(function(item, index){
                                    return (
                                    <span onClick={()=>{onTagClick(item.v)}} className={type == item.v ? "tag active" : "tag"}>
                                        {item.k} 
                                    </span>)
                                }) : '暂无数据'}
                                </Flex>
                            </div>
                            <div className='list-container'>
                                <Row>
                                {dataSource.length > 0 ? dataSource.map(function(item, index){
                                    return (
                                        <Col span={12}>
                                            <div onClick={() => {onListItemClick(item.code, item.name)}} className="list-li">
                                                <span className={unit.getTextClassName(index)}>{index+1}</span>
                                                {item.name === lastClickedName ? <u>{item.name}</u> : item.name}
                                            </div>
                                        </Col>
                                    );
                                }) : '暂无数据' }
                                </Row>
                            </div>
                        </div>
                    </Content>
                    <FooterComponent></FooterComponent> 
                </Layout>
            </Flex>
        </div>
    );
}

export default HotSearch;